import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { visuallyHiddenStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export interface StoreTableProps {
    overflowWrapper?: InjectableCss;
}

export const getTableCheckboxCellProps = (borderColor = "common.border", borderSide: "right" | "left" = "right") =>
    ({
        tight: true,
        css: css`
            width: 50px;
            ${`border-${borderSide}`}: 1px solid ${getColor(borderColor)};
            text-align: center;
            line-height: 1;

            span[role="checkbox"] + label {
                ${visuallyHiddenStyles()}
            }
        `,
    } as DataTableCellProps);

export const tableProps: StoreTableProps = {
    overflowWrapper: {
        css: css`
            width: 100%;
            overflow-x: auto;
        `,
    },
};
